import {
  axiosPatch,
  axiosPost,
} from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function SubmitForm({
  btnLoading,
  setBtnLoading,
  name,
  companyLink,
  role,
  id,
  file,
  isActionCreate
}) {
  if (!btnLoading) {
    setBtnLoading(true);
    try {
      var imgLink = "";
      if (file) {
        var endpoint = `${ApiConstants.BACKEND_BASE_URL}/homePage/updateOrganizer/${id}`;
        if (isActionCreate) {
          endpoint = `${ApiConstants.CREATE_HOME_ORGANIZER_CARD}`;
        }

        const formData = new FormData();
        formData.append("file", file);
        if (isActionCreate) {
          var res = await axiosPost({
            endpoint: endpoint,
            formData: formData,
          });
          console.log("res = ", res)
          imgLink = res.data.imageLink;
        } else {
          await axiosPatch({
            endpoint: endpoint,
            formData: formData,
          });
        }
      }

      var ep2 = `${ApiConstants.BACKEND_BASE_URL}/homePage/updateOrganizer/${id}`;
      if (isActionCreate) {
        ep2 = `${ApiConstants.CREATE_HOME_ORGANIZER_CARD}`;
        console.log("name = ", name, companyLink, role)
        await axiosPost({
          endpoint: ep2,
          jsonBody: JSON.stringify({
            name: name,
            companyLink: companyLink,
            role: "Co-organizer",
            imageLink: imgLink,
          }),
        });
      } else {
        await axiosPatch({
          endpoint: ep2,
          jsonBody: JSON.stringify({
            name,
            companyLink,
            role,
          }),
        });
      }

      console.log("first");
      // console.log("response = ", response);
      setBtnLoading(false);
      return true;
    } catch (error) {
      console.log("error = ", error);
      setBtnLoading(false);
      if (!error?.response) {
        console.log("No server response.");
        // console.log("Login credit Expired.\nPlease Login Again!!!");
      } else if (
        error.response?.status === 404 ||
        error.response?.status === 401
      ) {
        console.log("Server Error !!! Try Logging in again.");
      } else {
        console.log("Login credit Expired.\nPlease Login Again!!!");
      }
      return false;
    }
  }
}

export default SubmitForm;
